import {
	GiftCertificate as GiftCertificateType
} from '../../store/data/giftCertificates/types';

/**
 * Represents a gift certificate model
 */
class GiftCertificateModel {
	giftCertificate: GiftCertificateType;
	enabled: boolean;
	balance: number;
	currencyCode: string;

	/**
	 * @constructor
	 * @param {GiftCertificateType} giftCertificate - the gift certificate
	 */
	constructor(giftCertificate: GiftCertificateType) {
		Object.assign(this, giftCertificate);

		this.currencyCode = giftCertificate.c_currencyCode;
	};

	/**
	 * Checks if gift certificate is enabled
	 * @returns {Boolean} - is certificate enabled
	 */
	isEnabled(): boolean {
		return this.enabled;
	};

	/**
	 * Returns gift certificate balance
	 * @returns {Number} - amount
	 */
	getBalance(): number {
		return this.balance || 0;
	};

	/**
	 * Returns gift certificate currency Code
	 * @returns {string} - currency Code
	 */
	getCurrencyCode(): string {
		return this.currencyCode || '';
	}
}

export default GiftCertificateModel;